import React from 'react'
import {UserAvatarProps} from './types'
import UserAvatarView from './UserAvatarView'

const UserAvatar = (props: UserAvatarProps): React.ReactElement => {
    const {
        connected = false,
        highlight = false,
        iconOverride = undefined,
        idle = false,
        name = undefined,
        size,
        src = undefined,
        unread = false,
    } = props

    const [currentSrc, setCurrentSrc] = React.useState<string | undefined>(src)

    React.useEffect(() => {
        setCurrentSrc(src)
    }, [src])

    const handleError = React.useCallback((): void => {
        setCurrentSrc(undefined)
    }, [])

    const isLetterAvatar = !currentSrc
    const imageState = highlight ? 'highlight' : unread ? 'unread' : undefined
    const statusState = idle ? 'idle' : undefined


    return (
        <UserAvatarView
            connected={connected}
            highlight={highlight}
            iconOverride={iconOverride}
            imageState={imageState}
            isLetterAvatar={isLetterAvatar}
            name={name}
            onImageError={handleError}
            size={size}
            src={currentSrc}
            statusState={statusState}
            unread={unread}
        />
    )
}

export default UserAvatar
